import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBooking } from "./BookingModal";
import { useLang } from "../../i18n/LanguageContext";
import { LANGS } from "../../i18n/translations";
import { SEO } from "../../i18n/seo";

export const LangSwitcher = ({ solid }) => {
  const { lang, setLang } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onHome = !/^\/(book|admin)/.test(pathname);
  const choose = (e, code) => {
    e.preventDefault();
    if (onHome) navigate(SEO[code].path);
    else setLang(code);
  };
  return (
    <div
      data-testid="lang-switcher"
      className={`flex items-center gap-1 text-[11px] sm:text-xs tracking-wide ${
        solid ? "text-foreground/70" : "text-white drop-shadow-[0_1px_8px_rgba(0,0,0,0.6)]"
      }`}
    >
      {LANGS.map((l, i) => (
        <span key={l.code} className="flex items-center">
          <a
            data-testid={`lang-${l.code}`}
            href={SEO[l.code].path}
            hrefLang={l.code}
            onClick={(e) => choose(e, l.code)}
            aria-label={`Switch to ${l.label}`}
            className={`px-1 uppercase transition-colors hover:text-accent ${
              lang === l.code ? "text-accent font-semibold" : ""
            }`}
          >
            {l.label}
          </a>
          {i < LANGS.length - 1 && <span className="opacity-40">|</span>}
        </span>
      ))}
    </div>
  );
};

export const Header = () => {
  const [solid, setSolid] = useState(false);
  const { openBooking } = useBooking();
  const { t } = useLang();

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        solid
          ? "bg-background/80 backdrop-blur-xl border-b border-border/60"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="transition-opacity hover:opacity-80"
          aria-label="Tribe Beach — home"
        >
          <img
            src={solid ? "/logo-teal.png" : "/logo-sand.png"}
            alt="Tribe Beach Lounge logo"
            className={`h-9 md:h-11 w-auto ${solid ? "" : "drop-shadow-[0_2px_10px_rgba(0,0,0,0.55)]"}`}
          />
        </button>

        <div className="flex items-center gap-4 sm:gap-6">
          <LangSwitcher solid={solid} />
          <button
            data-testid="book-now-header"
            onClick={openBooking}
            className="inline-flex items-center bg-primary text-primary-foreground text-[10px] sm:text-xs uppercase tracking-luxe px-4 py-2.5 sm:px-6 sm:py-3 hover:bg-foreground transition-colors duration-300"
          >
            {t.common.book}
          </button>
        </div>
      </div>
    </header>
  );
};
